import ZwxScreen from './Index.vue'

ZwxScreen.install = function(Vue) {
  Vue.component(ZwxScreen.name, ZwxScreen)
}

export default ZwxScreen
